import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/corporatePolicyViolationCode', request)
}

export {get}
